<template>
  <div>
    <v-container fluid>
      <div class="main">
        <v-row>
          <v-col cols="12">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab>
                <v-icon left>mdi-account-multiple</v-icon>
                Gestion des comptes
              </v-tab>

              <v-tab>
                <v-icon left>mdi-key-variant</v-icon>
                Permissions
              </v-tab>

              <v-tab>
                <v-icon left>mdi-lock-check</v-icon>
                Rôles
              </v-tab>

              <v-tab>
                <v-icon left>mdi-file-document-outline</v-icon>
                Pages
              </v-tab>
            </v-tabs>

          </v-col>

          <v-col cols="12">
            <UsersList v-if="tab === 0" ref="usersListRef"/>
            <PermissionsList v-if="tab === 1" ref="permissionsListRef"/>
            <RolesList v-if="tab === 2" ref="rolesListRef"/>
            <PagesList v-if="tab === 3" ref="pagesListRef"/>
          </v-col>

        </v-row>
      </div>
    </v-container>
  </div>
</template>

<script>
import UsersList from "@/views/access-management/components/UsersList";
import PermissionsList from "@/views/access-management/components/PermissionsList";
import RolesList from "@/views/access-management/components/RolesList";
import PagesList from "@/views/access-management/components/PagesList";

export default {
  components: {PagesList, RolesList, PermissionsList, UsersList},
  data() {
    return {
      tab: 0
    }
  }
}
</script>

<style scoped>

</style>